<template>
  <div id="forget" class="secur-ity m-consumption">
    <div class="payment-page_son" v-show="alertBxo_Hidden">
      <alertBox @func="New_alertBox_Hidden" :vipji="vipji"></alertBox>
    </div>
    <div class="u-toptilte">
      <p>
        <i style="color: #ffcc00">▎</i>转账中心
      </p>
    </div>

    <p v-show="yshiming" class="yshiming">
      您还未进行实名认证，请先进行
      <a style="color: #356ded" @click="chongzhi">
        <u>实名认证</u>
      </a>后再进行转账操作。
    </p>

    <div class="form" v-show="wshiming">
      <el-form label-width="120px">
        <i style="margin-left: 25px">我的余额:</i>
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item label="海星点：" class="nice">
              <div class="nice_left">{{ balance }}</div>
              <el-checkbox
                class="nice_right"
                v-model="chrcked_er"
                v-show="zhoukaka"
                id="visiti"
                @change="forget22"
              ></el-checkbox>
            </el-form-item>
          </el-col>-->
          <el-col :span="12">
            <el-form-item label="海星点：" class="nice">
              <div class="nice_left">{{ balance }}</div>
              <el-checkbox
                class="nice_right"
                v-model="chrcked_er"
                v-show="zhoukaka"
                id="visiti"
                @change="forget22"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="12" :style="{ display: vipji > 3 ? 'block' : 'none' }">
            <el-form-item label="赠点：">
              <span>{{ jifen }}</span>
              <el-checkbox v-model="checked" v-show="zhoukaka" id="visiti" @change="forget23"></el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="对方手机号码：">
              <el-input placeholder="请输入对方手机号码" @blur="phonea" v-model="shuru.phone"></el-input>

              <div class="el-form-item__error">{{ cuowuspan.phone }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="转账点数：">
              <el-input
                placeholder="请输入转账点数"
                @blur="passa"
                v-model="shuru.pass"
                :class="[pass == false ? 'inputm' : 'inputh']"
              ></el-input>

              <div class="el-form-item__error">{{ cuowuspan.pass }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item label="备注：">
              <el-input v-model="shuru.note"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col>
            <el-form-item>
              <div class="u-btton">
                <el-button
                  type="warning"
                  round
                  :class="[checked == true ? 'Registerbtnl' : 'Registerbtnm']"
                  :id="[
                    shuru.note != '' && shuru.phone != '' && shuru.pass != ''
                      ? 'reg'
                      : 'feireg',
                  ]"
                  @click="forget"
                  style="border-radius: 5px"
                >&emsp;&emsp;&emsp;确认转账&emsp;&emsp;&emsp;</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import alertBox from './aletBox'
export default {
  components: {alertBox},
  metaInfo: {
    title: '云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content:
          '修改海星云账号,修改密码,云游戏:海星云平台,海星云,云游戏,5G云游戏,海星云主机,海星云电脑,海星云2080ti,云平台,星瀛科技,星瀛云,4K高清游戏,手机玩电脑游戏,移动端steam,移动端3A,下载牛牛游戏,牛牛游戏下载,牛牛游戏大厅,网络游戏,好玩的游戏,权利的游戏,网易游戏'
      },
      {
        name: 'description',
        content:
          '作为硬核玩家与极客团队，创造了星瀛科技（北京）有限公司，融入5G时代新应用产业的发展，自主研发高性能“海星云”云游戏平台，提供软硬件综合解决方案，让伙伴们不再是云玩家，在任意时间、任意地点、任意设备，共享高画质流畅体验。未来，我们的征途是星辰大海，勇气与胸怀是我们踏上远方的陪伴，迈向星河彼岸，须弥胜境。-修改海星云账号,修改密码'
      }
    ]
  },
  data () {
    return {
      zhoukaka: false,
      // 输入的数据
      shuru: {
        phone: '',
        pass: '',
        note: ''
      },
      // 错误的提示信息
      cuowuspan: {
        phone: '',
        pass: ''
      },
      // 标识符
      phone: false,
      pass: false,
      checked: false,
      chrcked_er: true,
      balance: '0',
      jifen: '',
      flag: 0,
      yshiming: true,
      wshiming: false,

      // 判断vip等级
      vipji: 0,
      // 控制弹框显示隐藏 yang
      alertBxo_Hidden: false
    }
  },
  methods: {
    chongzhi () {
      this.$router.push({
        path: './Real_name',
        query: {
          information: 1
        }
      })
    },
    forget22 (e) {
      this.flag = 0
    },
    forget23 () {
      this.flag = 1
    },
    forget () {
      if (this.shuru.note != '' && this.shuru.phone != '' && this.shuru.pass != '' && this.shuru.phone.length == 11) {
        this.alertBxo_Hidden = true
        if (this.shuru.phone == '' || this.shuru.pass == '') {
          return false
        } else if (this.phone == true || this.pass == true) {
          return false
        } else {
          this.http
            .transfer(this.shuru.phone, this.shuru.pass, this.shuru.note, this.flag)
            .then(res => {
              if (res.data.code == 200) {
                this.$message({
                  message: res.data.message,
                  type: 'success'
                })
                this.fGetMoney()
              } else {
                this.$message({
                  message: res.data.message,
                  type: 'warning'
                })
              }
            })
            .catch(err => {
              this.$message.error('系统繁忙,请稍后再试')
            })
        }
      }
    },
    // 这个是确认按钮 控制隐藏
    New_alertBox_Hidden (data) {
      this.alertBxo_Hidden = data
    },
    // 手机号
    phonea () {
      if (this.shuru.phone == '') {
        this.phone = true
        this.cuowuspan.phone = '请填写手机号'
        return false
      } else if (this.shuru.phone) {
        var reg = /^1[2-9][0-9]\d{8}$/
        if (reg.test(this.shuru.phone)) {
          this.phone = false
          this.cuowuspan.phone = ''
        } else {
          this.phone = true
          this.cuowuspan.phone = '手机号格式有误'
          return false
        }
      }
    },
    // 赠送点数 验证
    passa () {
      if (this.shuru.pass == '') {
        this.cuowuspan.pass = '请输入转账点数'
        this.pass = true
        return false
      } else if (this.shuru.pass) {
        var reg = /^([0-9]*)$/
        if (reg.test(this.shuru.pass)) {
          this.cuowuspan.pass = ''
          this.pass = false
        } else {
          this.cuowuspan.pass = '转账点数有误'
          this.pass = true
          return false
        }
      }
    },
    fGetMoney () {
      this.http.gerenzx().then(res => {
        this.jifen = res.data.data.bonus
        this.balance = res.data.data.userbalance
        if (res.data.data.vip_level >= 4) {
          this.zhoukaka = true
        } else {
          this.zhoukaka = false
        }
        if (res.data.data.active == true) {
          this.wshiming = true
          this.yshiming = false
        }
      })
    }
  },
  mounted () {
    this.token = this.$cookieStore.getCookie('user_sess')
    if (!this.token) {
      this.$message({
        message: '抱歉！您还没登录',
        type: 'warning'
      })
      return
    } else {
      this.vipji = this.$store.state.vip_level
    }
    this.fGetMoney()
  },
  watch: {
    // 'shuru.password' : function(){
    'checked': function () {
      if (this.checked == false) {
        this.chrcked_er = true
      } else if (this.checked == true) {
        this.chrcked_er = false
      }
    },
    'chrcked_er': function () {
      if (this.chrcked_er == false) {
        this.checked = true
      } else if (this.chrcked_er == true) {
        this.checked = false
      }
    }
  }
}
</script>
<style>
#visiti span {
  border-radius: 50%;
  /* background-color: #f4c91d; */
  border-color: white;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #f4c91d;
  border-color: white !important;
  color: black;
}
.nice_left {
  float: left;
}
.nice_right {
  float: left;
  margin-left: 5px;
}
.el-button--warning {
  background-color: #a6a9af !important;
  border-color: #a6a9af !important;
}
.el-checkbox__inner {
  background-color: transparent;
}
.el-checkbox__inner::after {
  border-color: black;
}
#reg {
  background: linear-gradient(90deg, #f3c304 0%, #ffe682 100%) !important;
  border-color: #f3c304;
  color: black;
}
#feireg {
  color: #ffffff8a;
}
#feireg:hover {
  color: #ffffff8a;
}
.payment-page_son {
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  /* background-color: #ffffff69; */
}
</style>



// WEBPACK FOOTER //
// src/components/Transfer.vue